import React from 'react';
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select, FormHelperText } from '@mui/material';

const GlobalMultiSelectFormik = ({
  label = 'Label Name',
  name, // formik field name
  formik, // full formik object
  data = [],
  keys = { id: 'id', value: 'id' }, // id = key, value = stored value
  disabled = false,
  fullWidth = true,
  sx,
}) => {
  const value = formik.values[name] || [];

  const handleChange = (event) => {
    const selectedContentId = event.target.value;
    if (selectedContentId.includes('id-all')) {
      if (value.length === data.length) {
        // clear all
        formik.setFieldValue(name, []);
      } else {
        // select all (ids or values)
        const allValues = data.map((item) => item[keys.id]);
        formik.setFieldValue(name, allValues);
      }
    } else {
      formik.setFieldValue(name, selectedContentId);
    }
  };

  const isAllSelected = value.length === data.length && data.length > 0;

  return (
    <FormControl
      fullWidth={fullWidth}
      sx={!fullWidth ? { minWidth: 220, maxWidth: 220, ...sx } : sx}
      error={Boolean(formik.touched[name] && formik.errors[name])}
    >
      <InputLabel>{label}</InputLabel>

      <Select
        multiple
        name={name}
        label={label}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        renderValue={(selected) =>
          selected
            .map((id) => {
              const item = data.find((d) => d[keys.id] == id);
              return item ? item[keys.value] : '';
            })
            .join(', ')
        }
      >
        {/* Select All */}
        <MenuItem value="id-all">
          <Checkbox checked={isAllSelected} />
          <ListItemText primary="Select All" />
        </MenuItem>

        {/* Options */}
        {data.map((item) => {
          const itemValue = item[keys.value];
          const itemId = item[keys.id];
          return (
            <MenuItem key={item[keys.id]} value={itemId}>
              <Checkbox checked={value.includes(itemId)} />
              <ListItemText primary={itemValue} />
            </MenuItem>
          );
        })}
      </Select>

      {formik.touched[name] && formik.errors[name] && <FormHelperText>{formik.errors[name]}</FormHelperText>}
    </FormControl>
  );
};

export default GlobalMultiSelectFormik;
